<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <SocialMediaPostAdd />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import SocialMediaPostAdd from "./components/SocialMediaPostAdd";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    SocialMediaPostAdd,
    // ProjectsTable,
  },
};
</script>
